// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"bb23da7e","680":"a5a63a4f"}[chunkId] + ".chunk.js";
};